import { render, staticRenderFns } from "./SalesRetur.vue?vue&type=template&id=ca3cc962"
import script from "./SalesRetur.vue?vue&type=script&lang=js"
export * from "./SalesRetur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports